<template>
  <main>
    <aside
      id="filters-drawer"
      class="drawer"
      :class="{
        open: filterDrawerStore.open,
        'wide-display': useWideDisplayBreakpoint,
      }"
      aria-labelledby="filters-heading"
    >
      <slot name="drawer" />
    </aside>
    <section
      class="content"
      :class="{ 'center-on-close': centerContentOnClose && !filterDrawerStore.open }"
      aria-label="Page content"
    >
      <slot name="content" />
    </section>
  </main>
</template>

<script setup>
import { useFilterDrawer } from '@/stores/filters/filterDrawer';

defineProps({
  useWideDisplayBreakpoint: {
    type: Boolean,
    default: true,
  },
  centerContentOnClose: {
    type: Boolean,
    default: false,
  },
});

const filterDrawerStore = useFilterDrawer();
</script>

<style lang="less" scoped>
main {
  position: relative;
  width: 100%;
  min-width: 1243px;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: start;
  grid-template-columns: auto 1fr;
  overflow: hidden;
}

.drawer {
  grid-column: 1;
  width: 0;
  min-width: 0;
  height: 100%;
  position: sticky;
  top: 0;
  left: 0;
  overflow-y: auto;
  overflow-x: hidden;
  opacity: 0;
  transition: all 400ms ease-in;

  &.open {
    width: 400px;
    min-width: 400px;
    opacity: 1;
    transition: all 400ms ease-out;
  }

  @media screen and (min-width: 1800px) {
    &.wide-display {
      width: 400px;
      min-width: fit-content;
      opacity: 1;
    }
  }
}

.content {
  grid-column: 2;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: grid;
  justify-items: start;
  align-items: start;

  &.center-on-close {
    justify-items: center;
  }
}
</style>
